import { createEntityAdapter } from "@reduxjs/toolkit";
import { Form } from "./dataTypes";

export const formAdapter = createEntityAdapter<Form>({});
